export const formatDecimalNumber = (input: string): string => {
    // Remove all non-numeric characters except the decimal point
    const cleaned = input?.replace(/[^0-9.]/g, "");

      // Ensure the input does not start with a decimal point
    if (cleaned.startsWith(".")) {
      return ""; // Reject the input if it starts with a decimal point
    }
  
    // Split the input into integer and decimal parts
    const [integerPart, decimalPart] = cleaned.split(".");
  
    // Limit the integer part to 3 digits
    const limitedInteger = integerPart?.slice(0, 3);

  
    // Limit the decimal part to 2 digits (if it exists)
    const limitedDecimal = decimalPart?.slice(0, 2);

  
    // Combine the integer and decimal parts
    if (limitedDecimal !== undefined) {
      return `${limitedInteger}.${limitedDecimal}`;
    }

    return limitedInteger;
  };
  


  